/*
  De miniaturenkolom van de kledingpagina.

  Alle foto's van het product staan in de kolom. Op een breed scherm past maar
  een deel ervan in beeld; twee pijlen schuiven de kolom een miniatuur op of
  neer. Op een telefoon is dezelfde rij een veegrail met puntjes — daar valt
  niets te schuiven en verdwijnen de pijlen vanzelf.

  Zonder JavaScript blijven alle miniaturen bereikbaar: de kolom is een gewoon
  scrollvlak, alleen zonder knoppen.
*/
(function () {
  'use strict';

  function start(vak) {
    var rail = vak.querySelector('[data-kleding-rail]');
    var terug = vak.querySelector('[data-kleding-mini-terug]');
    var verder = vak.querySelector('[data-kleding-mini-verder]');
    if (!rail || !terug || !verder) return;

    var INBEELD = 4;

    function kolomstand() {
      return window.matchMedia('(min-width: 1200px)').matches;
    }

    /*
      De hoogte van de kolom is die van de eerste vier miniaturen. Dat is een
      rekensom en geen vast getal, omdat een miniatuur de verhouding van de
      foto zelf aanhoudt: vier vierkante opnamen zijn lager dan vier staande.
    */
    function hoogte() {
      if (!kolomstand()) {
        rail.style.maxHeight = '';
        return;
      }

      var aantal = Math.min(INBEELD, rail.children.length);
      if (aantal < 1) return;

      var gat = parseFloat(window.getComputedStyle(rail).rowGap) || 0;
      var totaal = gat * (aantal - 1);
      for (var i = 0; i < aantal; i++) {
        totaal += rail.children[i].getBoundingClientRect().height;
      }
      if (totaal > 0) rail.style.maxHeight = Math.round(totaal) + 'px';
    }

    /* Eén miniatuur plus de tussenruimte: de stap van één klik. */
    function stap() {
      var eerste = rail.firstElementChild;
      if (!eerste) return 0;
      var gat = parseFloat(window.getComputedStyle(rail).rowGap) || 0;
      return eerste.getBoundingClientRect().height + gat;
    }

    /*
      De knoppen bestaan alleen zolang er iets te schuiven valt. Passen alle
      foto's in beeld, dan zijn twee pijlen die niets doen erger dan geen.
    */
    function ververs() {
      var ruimte = rail.scrollHeight - rail.clientHeight;
      var schuifbaar = ruimte > 1;

      terug.hidden = !schuifbaar;
      verder.hidden = !schuifbaar;
      if (!schuifbaar) return;

      terug.disabled = rail.scrollTop <= 1;
      verder.disabled = rail.scrollTop >= ruimte - 1;
    }

    /*
      Het schuiven is met de hand geschreven en niet met `behavior: 'smooth'`:
      zo is de stap altijd precies één miniatuur, en werken de pijlen ook in
      browsers die die optie niet kennen -- daar doet scrollBy anders niets.
    */
    var loopt = null;

    function schuif(richting) {
      var afstand = stap() * richting;
      if (!afstand) return;

      var van = rail.scrollTop;
      var naar = Math.max(0, Math.min(rail.scrollHeight - rail.clientHeight, van + afstand));
      if (naar === van) return;

      if (loopt) window.cancelAnimationFrame(loopt);

      /* Wie beweging heeft uitgezet, krijgt de sprong. */
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        rail.scrollTop = naar;
        ververs();
        return;
      }

      var begin = 0;
      var duur = 240;

      function stap_animatie(nu) {
        if (!begin) begin = nu;
        var deel = Math.min(1, (nu - begin) / duur);
        var soepel = deel < 0.5 ? 2 * deel * deel : -1 + (4 - 2 * deel) * deel;
        rail.scrollTop = van + (naar - van) * soepel;
        if (deel < 1) {
          loopt = window.requestAnimationFrame(stap_animatie);
        } else {
          /* Exact neerzetten: een halve pixel verschil snijdt een miniatuur af. */
          rail.scrollTop = naar;
          loopt = null;
          ververs();
        }
      }

      loopt = window.requestAnimationFrame(stap_animatie);
    }

    terug.addEventListener('click', function () { schuif(-1); });
    verder.addEventListener('click', function () { schuif(1); });

    var wacht = false;
    rail.addEventListener('scroll', function () {
      if (wacht) return;
      wacht = true;
      window.requestAnimationFrame(function () {
        wacht = false;
        ververs();
      });
    });

    function meten() {
      hoogte();
      ververs();
    }

    window.addEventListener('resize', meten);

    /*
      De miniaturen laden lui: vóór het laden is hun hoogte nul. Daarom opnieuw
      meten zodra er een binnenkomt, en nog eens als de pagina klaar is.
    */
    var beelden = rail.querySelectorAll('img');
    for (var b = 0; b < beelden.length; b++) {
      if (beelden[b].complete) continue;
      beelden[b].addEventListener('load', meten);
    }

    meten();
    window.addEventListener('load', meten);
  }

  /*
    Op een telefoon is de rail zo hoog als de hoogste foto. Staat er een
    vierkante opname tussen staande, dan blijft daaronder een gat van een paar
    honderd pixels staan. Daarom volgt de hoogte de foto die in beeld is.
  */
  function hoogteVolgtFoto(vak) {
    var rail = vak.querySelector('[data-kleding-rail]');
    if (!rail) return;

    function meet() {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        vak.style.height = '';
        return;
      }
      var breedte = rail.clientWidth;
      if (!breedte) return;

      /*
        Alleen meten als de rail stilstaat op een beeld. Midden in een veeg de
        hoogte veranderen laat de browser opnieuw zijn kleefpunt zoeken, en dan
        blijft hij tussen twee beelden hangen.
      */
      var rest = rail.scrollLeft % breedte;
      if (rest > 2 && rest < breedte - 2) return;

      var bij = Math.round(rail.scrollLeft / breedte);
      var kind = rail.children[bij] || rail.firstElementChild;
      if (!kind) return;
      var hoog = kind.getBoundingClientRect().height;
      if (hoog > 0) vak.style.height = Math.round(hoog) + 'px';
    }

    var klaar = null;
    rail.addEventListener('scroll', function () {
      if (klaar) window.clearTimeout(klaar);
      klaar = window.setTimeout(meet, 120);
    });

    window.addEventListener('resize', meet);

    var beelden = rail.querySelectorAll('img');
    for (var i = 0; i < beelden.length; i++) {
      if (beelden[i].complete) continue;
      beelden[i].addEventListener('load', meet);
    }

    meet();
    window.addEventListener('load', meet);
  }

  function alles(wortel) {
    var vakken = (wortel || document).querySelectorAll('[data-kleding-minivak]');
    for (var i = 0; i < vakken.length; i++) {
      start(vakken[i]);
      hoogteVolgtFoto(vakken[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alles(); });
  } else {
    alles();
  }

  /* In de theme editor wordt een sectie opnieuw ingevoegd zonder herladen. */
  document.addEventListener('shopify:section:load', function (e) { alles(e.target); });
})();
